import * as colors from './colors';
export const input = {
  size: '1.6rem'
};
export const label = {
  size: '1.6rem'
};
export const helper = {
  size: '1.6rem'
};
export const border = {
  color: colors.oriGrey[500]
};
export const selectedMark = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' style='width: 24px; height: 24px; fill: %2332a58e;'%3E%3Cpath d='M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m12.351-2.144a.5.5 0 1 0-.702-.712l-4.708 4.65-2.13-1.686a.5.5 0 0 0-.621.784l2.825 2.234z'%3E%3C/path%3E%3C/svg%3E")`;
export const inputFontSizes = {
  input: {
    mobile: input.size
  },
  'input-label': {
    mobile: label.size
  },
  'input-helper': {
    mobile: helper.size
  }
};
//# sourceMappingURL=textInputData.js.map